import { useState, useEffect } from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import useForm from '../../../hooks/useForm';
import StyledModal from '../StyledModal';
import GreenBorderBox from '../../common/GreenBorderBox';
import { Button as StyledButton, TextField } from '../../common';
import colors from '../../../assets/colors';
import EditInfoParametersAnimals from './EditInfoParametersAnimals';
import { incomeParameters } from '../../../utils/api';
import MassEditAnimalParametersModal from './MassEditAnimalParametersModal';

export default function EditParametersAnimalsModal(props) {
  const [editInfoModalOpen, setEditInfoModalOpen] = useState(false);
  const [massEditOpen, setMassEditOpen] = useState(false);
  const [currentlySelected, setCurrentlySelected] = useState(0);
  const { handleChange, setFieldValue, values } = useForm({
    value: 0,
  });

  const handleClose = () => props.setOpen(false);
  const handleConfirm = () => {
    setEditInfoModalOpen(true);
  };

  const setData = () => {
    setFieldValue('value', props.selectionData[currentlySelected]?.incomeValue);
  };

  useEffect(() => {
    setData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData();
    //eslint-disable-next-line
  }, [currentlySelected]);

  const increaseSelected = () => {
    if (currentlySelected + 1 < props.selected?.length)
      setCurrentlySelected((prev) => prev + 1);
  };

  const decreaseSelected = () => {
    if (currentlySelected - 1 >= 0) setCurrentlySelected((prev) => prev - 1);
  };

  const editParameter = () => {
    const body = {
      id: props.selectionData[currentlySelected].id,
      incomeValue: values.value,
    };
    if (props.local) {
      props.setData(
        props.data.map((el) =>
          el.id === body.id
            ? { ...el, incomeValue: body.incomeValue, edited: true }
            : el
        )
      );
    } else {
      incomeParameters
        .editAnimalParameter(props.selectionData[currentlySelected].id, body)
        .then((res) => {
          props.updateParameters();
        })
        .catch((err) => {});
    }
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Box>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
              Edytuj wskaźniki
            </Typography>
            {props.selected?.length > 1 && (
              <Button variant="contained" sx={{ mx: 2 }}>
                {currentlySelected + 1 + ' z ' + props.selected?.length}
              </Button>
            )}
          </Grid>
          <GreenBorderBox>
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              columnSpacing={10}
            >
              <Grid container item xs={4} direction="column" rowSpacing={1}>
                <Grid item>
                  <Typography sx={{ color: colors.agroweGreen }}>
                    Nazwa zwierzęcia
                  </Typography>
                </Grid>
                <Grid item>
                  {props.selectionData[currentlySelected]?.animalName}
                </Grid>
              </Grid>
              <Grid container item xs={4} direction="column" rowSpacing={1}>
                <Typography sx={{ color: colors.agroweGreen }}>
                  Wartość wskaźnika
                </Typography>
                <Grid item>
                  {props.selectionData[currentlySelected]?.incomeValue} PLN
                </Grid>
              </Grid>
            </Grid>
          </GreenBorderBox>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            columnSpacing={5}
            sx={{ mt: 3, p: 4 }}
          >
            <Grid container item xs={4} direction="column">
              <TextField
                label="Aktualny wskaźnik"
                variant="standard"
                modal
                disabled
                value={props.selectionData[currentlySelected]?.animalName}
                sx={{
                  '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: '#000000',
                  },
                }}
              />
            </Grid>
            <Grid container item xs={4} direction="column">
              <TextField
                label="Wskaźnik do:"
                variant="standard"
                modal
                disabled
                value={'1 szt'}
                sx={{
                  '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: '#000000',
                  },
                }}
              />
            </Grid>
            <Grid container item xs={4} direction="column">
              <TextField
                label="Wartość PLN"
                modalRight
                variant="outlined"
                value={values.value}
                onChange={handleChange('value')}
              />
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-evenly"
            sx={{ mt: 2 }}
            columnSpacing={1}
          >
            {props.selected?.length > 1 && (
              <>
                <Grid item container xs={4}>
                  <Grid item>
                    <Button variant="outlined" onClick={decreaseSelected}>
                      POPRZEDNI
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained">
                      {currentlySelected + 1 + ' z ' + props.selected?.length}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" onClick={increaseSelected}>
                      NASTĘPNY
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <StyledButton
                    variant="contained"
                    sx={{ height: 40 }}
                    onClick={() => setMassEditOpen(true)}
                  >
                    EDYTUJ MASOWO WPISY
                  </StyledButton>
                </Grid>
              </>
            )}
            <Grid item xs={4}>
              <Button variant="outlined" onClick={handleConfirm}>
                ZAPISZ
              </Button>
            </Grid>
          </Grid>
        </Box>
      </StyledModal>
      {editInfoModalOpen && (
        <EditInfoParametersAnimals
          open={editInfoModalOpen}
          setOpen={setEditInfoModalOpen}
          selected={props.selected}
          selectionData={props.selectionData}
          currentlySelected={currentlySelected}
          newValue={values.value}
          editParameter={editParameter}
        />
      )}
      {massEditOpen && (
        <MassEditAnimalParametersModal
          local={props.local}
          data={props.data}
          setData={props.setData}
          open={massEditOpen}
          setOpen={setMassEditOpen}
          selected={props.selected}
          updateParameters={props.updateParameters}
        />
      )}
    </>
  );
}
